import styled from 'styled-components'

import COLORS from '@colors'

export const Main = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
`

export const Header = styled.h2`
  font-size: 20px;
  font-weight: bold;
  color: ${COLORS.leather};
  margin-bottom: 44px;
`

export const FormContainer = styled.div`
  background-color: ${COLORS.gray28};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: 40px;
  width: 38%;
`

export const FormWrapper = styled.div`
  width: 335px;
`

export const LogoWrapper = styled.div`
  margin-bottom: 100px;
  margin-top: 100px;
`

export const ImageContainer = styled.img`
  width: 62%;
`

export const Error = styled.p`
  font-size: 12px;
  margin-top: 6px;
  color: ${COLORS.rustyRed};
`
